import { createSelector } from 'reselect';
import { getCollectionsNew } from '../collections';

export const getCollectionMeta = createSelector([getCollectionsNew], (collection) => ({
  _id: collection._id,
  description: collection.description,
  created_at: collection.created_at,
  updated_at: collection.updated_at,
  activeTab: collection.activeTab,
  customDomain: collection.customDomain,
  _galleryPreset: collection._galleryPreset,
  _user: collection._user
}));
